import {ActionReducer, createReducer, on} from '@ngrx/store';
import {HttpActionState} from '../../../pages/users/userslisting/store/users-listing.reducers';
import {IGetSavedListingFiltersResponseDTO} from '../save-filters.dto';

import * as SavedFiltersActions from './saved-filters.actions';

export interface ISavedFiltersState {
    fetchFiltersRequest: HttpActionState;
    deleteFiltersRequest: HttpActionState;
    updateFiltersRequest: HttpActionState;
    filters:IGetSavedListingFiltersResponseDTO []
    selectedSavedFilter:IGetSavedListingFiltersResponseDTO
}

const initialState: ISavedFiltersState = {
    deleteFiltersRequest: HttpActionState.Init,
    updateFiltersRequest: HttpActionState.Init,
    fetchFiltersRequest: HttpActionState.Init,
    filters:[],
    selectedSavedFilter:null
}


export const reducer: ActionReducer<ISavedFiltersState> = createReducer<ISavedFiltersState>(initialState,
    on(SavedFiltersActions.resetState, () => ({
        ...initialState
    })),
    on(SavedFiltersActions.fetchSavedFilters, (state)=>({
        ...state,
        fetchFiltersRequest: HttpActionState.Busy,
    })),
    on(SavedFiltersActions.fetchSavedFiltersSucceeded, (state,{filters} )=>({
        ...state,
        fetchFiltersRequest: HttpActionState.Done,
        filters:filters
    })),
    on(SavedFiltersActions.saveFiltersSucceeded, (state, {filter})=>({
        ...state,
        filters: [
            ...state.filters,
            ...[filter]
        ]
    })),

    on(SavedFiltersActions.fetchSavedFiltersFailed, (state)=>({
        ...state,
        fetchFiltersRequest: HttpActionState.Failed,
    })),

    on(SavedFiltersActions.editSavedFilter, (state)=>({
        ...state,
        updateFiltersRequest:HttpActionState.Busy
    })),

    on(SavedFiltersActions.editSavedFilterSucceeded, (state, {filter})=>({
        ...state,
        filters: updateFilter(  [...state.filters], filter)
    })),

    on(SavedFiltersActions.editSavedFilterFailed, (state)=>({
        ...state,
        updateFiltersRequest:HttpActionState.Failed
    })),

    on(SavedFiltersActions.deleteSavedFilter, (state)=>({
        ...state,
        deleteFiltersRequest:HttpActionState.Busy
    })),
    on(SavedFiltersActions.deleteSavedFilterSucceeded, (state, {filterId})=>({
        ...state,
        deleteFiltersRequest:HttpActionState.Done,
        filters: deleteFilter(filterId, [...state.filters])
    })),
    on(SavedFiltersActions.deleteSavedFilterFailed, (state)=>({
        ...state,
        deleteFiltersRequest:HttpActionState.Failed
    })),
    on(SavedFiltersActions.filterSelected, (state, {filter})=>({
        ...state,
        selectedSavedFilter:filter
    })),
    on(SavedFiltersActions.clearSelectedFilter, (state) =>({
        ...state,
        selectedSavedFilter: initialState.selectedSavedFilter
    }))
);


function deleteFilter(filterId:number, list: IGetSavedListingFiltersResponseDTO[]) :IGetSavedListingFiltersResponseDTO[] {
    const index = list.findIndex(x=>x.id === filterId);
    if(index > -1) {
        list.splice(index,1);
    }

    return list;
}

function updateFilter(filters: IGetSavedListingFiltersResponseDTO[], filter:Partial<IGetSavedListingFiltersResponseDTO>):  IGetSavedListingFiltersResponseDTO[]{
    const index = filters.findIndex(x=>x.id === filter.id);
    if(index > -1) {
        filters[index] = {
            ...filters[index],
            ...filter
        }
    }
    return filters;
}
